import { TextFieldProps } from "@mui/material/TextField";
import React from "react";

import ignoreProps from "../../utils/ignore-props";
import Autocomplete, { Option } from "../Autocomplete";
import useStaff from "./useStaff";

interface FormControlProps {
  variant?: "outlined" | "filled" | "standard";
  size?: "small" | "medium";
  className?: string;
}

interface StaffSelectProps {
  value?: string;
  verticals?: string[];
  formControlProps?: FormControlProps;
  optionsHook?: OptionsHook;
  ticketSlug?: string;
  department?: string;
}

function StaffSelect(props: StaffSelectProps & NativeTextFieldProps) {
  const {
      id,
      name,
      onChange,
      value,
      disabled,
      className,
      formControlProps,
      optionsHook: useOptionsHook = useStaff,
      ...rest
    } = props,
    textFieldProps = ignoreProps(rest, IGNORE_PROPS),
    resolvedClassName = formControlProps?.className || className,
    mergedTextFieldProps = {
      ...textFieldProps,
      ...(formControlProps?.size ? { size: formControlProps.size } : {}),
      ...(formControlProps?.variant
        ? { variant: formControlProps.variant }
        : {}),
    },
    { getOptionById, getOptions } = useOptionsHook(props);

  return (
    <Autocomplete
      className={resolvedClassName}
      disabled={disabled}
      getOptionForValue={getOptionById}
      getOptions={getOptions}
      id={id}
      name={name}
      onChange={onChange}
      textFieldProps={mergedTextFieldProps}
      value={value}
    />
  );
}

export default StaffSelect;

const IGNORE_PROPS = new Set([
  "getStaffById",
  "updateStaff",
  "getStaff",
  "getAgentOptions",
  "getAgentOptionById",
  "ticketSlug",
  "department",
]);

type NativeTextFieldProps = Omit<TextFieldProps, "value">;

type OptionsHook = (props?: any) => OptionHooksReturn;

type OptionHooksReturn = {
  getOptionById: (value: string) => Promise<Option | null>;
  getOptions: (value: string) => Promise<Option[]>;
};
